import api from 'api';

export const loadAffiliateGrid = api('POST /api/affiliates/grid');
export const exportAffiliates = api('GET /api/affiliates/export', {
  responseType: 'blob',
});

export const loadAffiliateDetails = api('GET /api/affiliates/:id/details');
export const loadAffiliate = api('GET /api/affiliates/:id');
export const createAffiliate = api('POST /api/affiliates');
export const updateAffiliate = api('PUT /api/affiliates/:id');

export const archiveAffiliate = api('POST /api/affiliates/:id/archive');
export const restoreAffiliate = api('POST /api/affiliates/:id/restore');
export const moveToTestAffiliate = api('POST /api/affiliates/:id/in-test');
export const qaAffiliate = api('POST /api/affiliates/:id/qa');

export const commentAffiliate = api('POST /api/affiliates/:id/comment');
